/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// `MetadataOverrider` has been moved to core/testing to allow using it from the render3 TestBed
export {ÉµMetadataOverrider as MetadataOverrider} from '@angular/core/testing';
